import { CategoryBadge } from "@gromia/components/blog/Badges";
import {
  BannerAside,
  BannerAsideValuation,
  BannerBottom,
} from "@gromia/components/blog/Banner";
import { Pagination } from "@gromia/components/blog/Pagination";
import { PostLinkCard, PostLinkThumb } from "@gromia/components/blog/PostLink";
import {
  navigateToSearch,
  SearchField,
} from "@gromia/components/blog/SearchField";
import * as s from "@gromia/components/theme/t.module.css";
import { Layout } from "@gromia/components/ui/Layout";
import { Sticky, stickyPad } from "@gromia/components/ui/Sticky";
import {
  BlogListPage,
  pathToHomePage,
  WpCatTagT,
  WpListStats,
} from "@gromia/utils/models/blog";
import { wrapStaticString } from "@gromia/utils/useString";
import cx from "classnames";
import * as A from "fp-ts/lib/Array";
import * as O from "fp-ts/lib/Option";
import * as React from "react";
import { Seo } from "../Seo";

const SeoStringsMap = {
  blog: {
    title: "Blog",
    description:
      "Vivi al meglio la tua casa. Consigli su interior design, normative e vita fra coinquilini!",
  },
  research: {
    title: "Centro Studi",
    description:
      "Analisi approfondite, statistiche aggiornate e dati esclusivi sull'andamento dei mercati immobiliari italiani. Scopri le tendenze, i report settoriali e le previsioni elaborate dai nostri esperti per investire con consapevolezza",
  },
};

function Page(props: {
  pageContext: {
    page: BlogListPage;
    categoriesAndTags: (WpCatTagT & WpListStats)[];
    research?: boolean;
  };
}) {
  const page = props.pageContext.page;
  const SeoStrings = props.pageContext.research
    ? SeoStringsMap.research
    : SeoStringsMap.blog;

  return (
    <Layout headerAlwaysLight>
      <Seo
        title={wrapStaticString(SeoStrings.title)}
        description={wrapStaticString(SeoStrings.description)}
      />
      <div className={cx(s.bgWhite)}>
        <div className={cx(s.container, s.space2)}>
          <div className={cx(s.row)}>
            <div className={cx(s.col, s.col12, s.colLg8)}>
              <ul className={cx(s.listUnstyled)}>
                {page.posts.map((post, idx) => (
                  <li key={idx} className={cx(idx > 0 ? s.mt6 : null)}>
                    <PostLinkCard post={post} />
                  </li>
                ))}
              </ul>
              <Pagination pagination={pathToHomePage} page={page} />
            </div>
            <div
              className={cx(s.dNone, s.dLgBlock, s.col, s.colLg4)}
              data-track="sidebar-blog-home"
            >
              <Sticky top={stickyPad}>
                {() =>
                  props.pageContext.research
                    ? <SidebarResearchCenter />
                    : <SidebarHome page={page} />}
              </Sticky>
            </div>
          </div>
        </div>
      </div>
      <BannerBottom target={O.none} />
    </Layout>
  );
}

function SidebarHome(props: { page: BlogListPage }) {
  const page = props.page;
  const topPosts = A.takeLeft(3)(page.topPosts);
  const topCategories = page.topCategories;

  return (
    <React.Fragment>
      <SearchField onChange={navigateToSearch} />
      <div className={cx(s.pt6)}>
        <span
          className={cx(
            s.textBody,
            s.fontWeightBold,
            s.fontSizeLarge2,
          )}
        >
          I temi del momento
        </span>
        <ul className={cx(s.listUnstyled, s.mN1, s.pt3)}>
          {topCategories.map((c, idx) => (
            <li key={idx} className={cx(s.dInlineBlock, s.p1)}>
              <CategoryBadge category={c} />
            </li>
          ))}
        </ul>
      </div>
      <div className={cx(s.pt6)}>
        <BannerAside target={O.none} />
      </div>
      <div className={cx(s.pt6)}>
        <span
          className={cx(
            s.textBody,
            s.fontWeightBold,
            s.fontSizeLarge2,
          )}
        >
          I più letti
        </span>
        <ul className={cx(s.listUnstyled, s.mt5)}>
          {topPosts.map((p, idx) => (
            <li
              key={p.databaseId}
              className={cx(idx > 0 ? s.mt5 : null)}
            >
              <PostLinkThumb post={p} />
            </li>
          ))}
        </ul>
      </div>
    </React.Fragment>
  );
}

function SidebarResearchCenter() {
  return (
    <React.Fragment>
      <div className={cx()}>
        <BannerAsideValuation target={O.none} />
      </div>
    </React.Fragment>
  );
}

export default Page;
